import { Component } from 'react';
import classNames from 'classnames';
import { Avatar } from '@beisen/chaos-ui';
import * as uHtml from '../../util/html';
import * as helper from '../../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
require('./StandardTableItem.scss');

const defaultTranslation = {
  picTotal: '等$count张图片'
};

export default class StandardTableItem extends Component {
  constructor(props) {
    super(props);
    this.translation = Object.assign({}, defaultTranslation, transLoader({
      picTotal: 'fileUpload.picTotal'
    }), props.translation);
  }

  disableLink() { //禁止点击跳转，预览附件等跳转动作
    return ['batchTable', 'popViewTable'].includes(this.props.tableType);
  }

  picLinkTouchHandler(pic, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.setClickPos && this.props.setClickPos(this.props.index);
    //文件名集合
    const picConentArr = pic.content && pic.content.split(',');
    //url集合
    const picValueArr = pic.clientUrl && pic.clientUrl.split(',');
    const picDownloadArr = pic.downloadUrl && pic.downloadUrl.split(',');
    let picObjArr = [];
    picConentArr.forEach((con, index) => {
      let picObj = {};
      picObj['name'] = con.trim();
      picObj['url'] = picValueArr[index].trim();
      picObj['downloadUrl'] = picDownloadArr[index].trim();
      picObjArr.push(picObj);
    });
    window.appHelper.picPreview(picObjArr, { backToTable: true, downloadable: true });
  }

  getPicLink(item, cls) {
    const picItems = item ? item.content.split(',') : [];
    const picName = picItems[0] || '';
    const picLastName = picName.slice(picName.lastIndexOf('.'));
    const picFirstName = picName.slice(0, picName.lastIndexOf('.'));
    const picTotal = picItems.length;
    return (<span className={(cls || '') + ' piclink'}>
      {item.title ? `${item.title}: ` : ''}
      <span className='pichot'//tableType==='batchTable'是编辑页面渲染列表，不能有touch事件
        onTouchTap={this.disableLink() ? null : this.picLinkTouchHandler.bind(this, item)}>
        <span className='firstname'>
          <span>{picFirstName}</span>
        </span>
        <span>{picLastName ? `${picLastName}` : ''}</span>
      </span>
      <span>{picTotal == 0 || picTotal == 1 ? '' : this.translation.picTotal.replace('$count', picTotal)}</span>
    </span>);
  }

  fileLinkTouchHandler(file, e) {
    if (helper.isImage(file.value) == true) {//如果是图片
      this.picLinkTouchHandler(file, e);
      return false;
    }
    e.preventDefault();
    e.stopPropagation();
    this.props.setClickPos && this.props.setClickPos(this.props.index);
    const path = file.value;
    const domain = this.props.domain || '';
    if (path) {
      const index = path.indexOf('//') + 2;
      const keyspace = path.substring(index, path.indexOf('/', index));
      const id = path.substring(path.lastIndexOf('/') + 1);
      const url = `${domain}/${BSGlobal['loginUserInfo']['TenantID']}/preview/${keyspace}/${id}`;
      const params = {
        title: file.content || '',
        url: url,
        scaleEnabled: BSGlobal.application == 'ELearning' ? true : false,
        screenOrientation: BSGlobal.application == 'ELearning' ? 'auto' : '',
        backToTable: true,
        downloadUrl: file.downloadUrl,
        useNativePreview: true
      };
      window.appHelper.attachmentPreview(params, domain);
    }
  }

  getFileLink(item) {
    return (
      <span className='filelink'>
        {item.title ? `${item.title}: ` : ''}<br />
        <span className='file-icon'//tableType==='batchTable'是编辑页面渲染列表，不能有touch事件
          onTouchTap={this.disableLink() ? null : this.fileLinkTouchHandler.bind(this, item)}>
        </span><br />
        <span className='filename'>{item.content || ''}</span>
      </span>
    );
  }

  getSubInfo(subInfo) {
    if (subInfo && subInfo.length > 0) {
      return (
        <ul>
          {subInfo.map((item, index) => {
            const isPicTag = item.ControlType === 'PicUpload' || item.ControlType === 'MultiplePicUpload';
            const isFileUpload = item.ControlType === 'FileUpload';
            return (
              <li key={index} data-index={index}>
                {isPicTag ? this.getPicLink(item) : (isFileUpload && item.value ? this.getFileLink(item) : item.title + ': ' + (item.content ? item.content : ''))}
              </li>);
          })}
        </ul>);
    } else {
      return null;
    }
  }

  getMainInfo(showChecked, mainInfo, subInfo) {
    if (mainInfo) {
      const titleText = (this.props.mainInfo.title == ' ' || this.props.mainInfo.title == '' || !this.props.mainInfo.title) ? '---' : this.props.mainInfo.title;
      const subTitleText = (this.props.mainInfo.subTitle == ' ' || this.props.mainInfo.subTitle == '' || !this.props.mainInfo.subTitle) ? '' : this.props.mainInfo.subTitle;
      let title = (
        <div
          onTouchTap={this.onTouchTap}
          className={classNames('main-title', {
            'empty-margin-bottom': !subTitleText
          }, {
            'empty-content': (subInfo && subInfo.length == 0) || !subInfo
          })}
        >
          {uHtml.decode(titleText)}
        </div>
      );
      let subTitle = (subTitleText ? <div className='submain-title'
      >{uHtml.decode(subTitleText)}</div> : null);
      if (this.props.mainInfo.mainType && this.props.mainInfo.mainClientUrl) {//如果有mainType说明是图片或者单附件字段
        const pic = { 'content': this.props.mainInfo.title, 'clientUrl': this.props.mainInfo.mainClientUrl };
        const file = { 'value': this.props.mainInfo.title, 'clientUrl': this.props.mainInfo.mainClientUrl };
        title = this.props.mainInfo.mainType == 'pic' ? this.getPicLink(pic, 'main-title') : this.getFileLink(file);
      }
      if (this.props.mainInfo.subType && this.props.mainInfo.subClientUrl) {
        const pic = { 'content': this.props.mainInfo.subTitle, 'clientUrl': this.props.mainInfo.subClientUrl };
        const file = { 'value': this.props.mainInfo.title, 'clientUrl': this.props.mainInfo.subClientUrl };
        subTitle = this.props.mainInfo.subType == 'pic' ? this.getPicLink(pic, 'submain-title') : this.getFileLink(file);
      }

      let subInfos;
      subInfos = this.getSubInfo(subInfo);
      return (
        <div className={classNames('info-container', { 'check-pos': showChecked })}>
          {title}
          {subTitle}
          {subInfos}
        </div>
      );
    } else {
      return null;
    }
  }

  getMediaInfo(showChecked, mainInfo) {
    if (mainInfo.showMedia && this.props.showMedia) {
      return (
        <div className='media-container'>
          <Avatar { ...mainInfo } scale='big' />
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    let { subInfo, mainInfo, showChecked, checked, showMedia } = this.props;
    return (<div className={classNames('standard-main-content', { 'showMedia': showMedia })}>
      {this.getMediaInfo(showChecked, mainInfo)}
      {this.getMainInfo(showChecked, mainInfo, subInfo)}
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table_Components/StandardTableItem/StandardTableItem.js